export const pageTitle = (title) => {
  return (document.title = title + " -  VDOC - Medical and Healthcare App");
};
